import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CoreService } from '../../helper/core/core.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { NgModel, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { registerLocaleData, Location } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { BuNameService } from '../../helper/core/bu-name.service';
import { UtilsService } from '../../helper/utils/utils.service';
import { NgSelectComponent } from '@ng-select/ng-select';


@Component({
  selector: 'app-lieu',
  templateUrl: './lieu.component.html',
  styleUrls: ['./lieu.component.scss']
})
export class LieuComponent implements OnInit {


  @ViewChild('regionComp') regionComp: NgSelectComponent;
  @ViewChild('villeComp') villeComp: NgSelectComponent;
  @ViewChild('lieuComp') lieuComp: NgSelectComponent;

  public idRegion: string = "";
  public idVille: string = "";
  public idLieu: string = "";
  public buSlug: string = "";
  public eventSlug: string = "";
  public event: any = false;
  public errorMsg: string = "";
  public errorApi: boolean = false;
  public today: Date = new Date();

  public formPlaces: FormGroup;
  public objectKeys = Object.keys
  public filtres: any;
  public dataRegionSelect: any;
  public dataVille: any = false;
  public dataVilleSelect: any;
  public dataLieu: any = false;
  public dataLieuSelect: any;
  public dataBoutiques: any = false;
  public dataVirtualEvents: any = false;
  public selectRegion: any;
  public selectVille: any;
  public selectLieu: any;

  public dataBoutiquesOther: any = false;

  region = new FormControl();
  ville = new FormControl();
  lieu = new FormControl();

  @Input() data;
  @Output() dataChange = new EventEmitter();

  constructor(private route: ActivatedRoute,
    private coreService: CoreService,
    private buNameService: BuNameService,
    private fb: FormBuilder,
    private router: Router,
    private utils: UtilsService,
    private location: Location) {
  }

  ngOnInit() {
    $(document).ready(function () {
      $(document).foundation();
    });
    this.data = { ...this.data }

    this.region.setValue(this.data.region)
    this.ville.setValue(this.data.ville)
    this.lieu.setValue(this.data.lieu)


    this.formPlaces = this.fb.group({
      region: this.region,
      ville: this.ville,
      lieu: this.lieu
    });


    this.dataVille = this.region
    this.formValid()


    /**
     * On récupère le slug de BU et de EVENT
     */
    this.buSlug = this.route.snapshot.paramMap.get('bu');
    this.eventSlug = this.route.snapshot.paramMap.get('event');
    this.idRegion = this.route.snapshot.paramMap.get('regionSlug');
    this.idVille = this.route.snapshot.paramMap.get('villeSlug');
    this.idLieu = this.route.snapshot.paramMap.get('lieuSlug');

    /**
     * API pour récupérer
     * Les informations de l'EVENT
     */
    this.getEventInformation(this.eventSlug);

    registerLocaleData(localeFr, 'fr');
  }

  /**
   * On vient de modifier la valeur du select 'Région'
   */
  private changeRegion(): void {

    // On vide le select 'Lieu' et 'Ville' et on le passe en disabled
    this.dataLieu = false;
    this.dataLieuSelect = new Array();
    if (this.lieuComp)
      this.lieuComp.itemsList.clearSelected();
    if (this.villeComp)
      this.villeComp.itemsList.clearSelected();

    // On vide la section de résultat
    this.dataBoutiques = false;

    // Si la valeur du select 'Région' est nulle : On vide le select 'Ville'
    if (this.dataRegionSelect == null) {
      this.dataVille = false;
      this.dataVilleSelect = new Array();
      this.villeComp.itemsList.clearSelected();
      // Sinon on remplit le select 'Ville' avec la selection du select 'Région'
    } else {
      // Array Ville
      this.dataVille = this.filtres[this.formPlaces.value.region].cities;

      // MAJ options select
      this.dataVilleSelect = new Array();
      this.objectKeys(this.dataVille).forEach((key) => {
        this.dataVilleSelect = [
          ...this.dataVilleSelect,
          {
            "id": key,
            "name": this.dataVille[key].name
          }
        ]
      });
    }

    // change URL
    const url = this
      .router
      .createUrlTree(['/' + this.buSlug, this.eventSlug, this.formPlaces.value.region])
      .toString();
    this.location.go(url);
  }

  /**
   * On vient de modifier la valeur du select 'Ville'
   */
  private changeVille(): void {
    // On vide le select 'Lieu' et 'Ville' et on le passe en disabled
    this.dataLieu = false;
    this.dataLieuSelect = new Array();
    if (this.lieuComp)
      this.lieuComp.itemsList.clearSelected();

    // Si la valeur du select 'Ville' est nulle : On vide le select 'Lieu'
    if (this.dataVilleSelect == null || this.dataVilleSelect == false || this.dataVilleSelect == undefined) {
      this.dataLieu = false;
      this.dataLieuSelect = new Array();
      this.lieuComp.itemsList.clearSelected();
    } else {
      // Sinon on remplit le select 'Lieu' avec la selection du select 'Ville'
      this.dataLieu = this.dataVille[this.formPlaces.value.ville].places;

      // MAJ options select
      this.dataLieuSelect = new Array();
      this.objectKeys(this.dataLieu).forEach((key) => {
        this.dataLieuSelect = [
          ...this.dataLieuSelect,
          {
            "id": key,
            "name": this.dataLieu[key].name
          }
        ]
      });
    }


    // On remplit la section de résultat
    this.dataBoutiques = new Array();
    this.objectKeys(this.dataLieu).forEach((key) => {
      this.dataBoutiques.push(this.dataLieu[key]);
    });

    // slider slots
    $(document).ready(() => {
      $(document).foundation();

      // Scroll to filtres & list shop
      if ($(".form-places__container").length) {
        $('html, body').animate({
          scrollTop: $(".form-places__container").offset().top - $('.header__container').height()
        }, 750);
      }
    });
    const url = this
      .router
      .createUrlTree(['/' + this.buSlug, this.eventSlug, this.formPlaces.value.region, this.formPlaces.value.ville])
      .toString();
    this.location.go(url);
  }

  private changeLieu(): void {
    // On remplit la section de résultat
    this.dataBoutiques = new Array();

    if (this.dataLieuSelect == null) {
      this.dataLieu = this.dataVille[this.formPlaces.value.lieu].places;
      this.objectKeys(this.dataLieu).forEach((key) => {
        this.dataBoutiques.push(this.dataLieu[key]);
      });
    } else {
      this.dataBoutiques.push(this.dataLieu[this.formPlaces.value.lieu]);

      this.dataChange.emit({
        ...this.data,
        dates: this.dataBoutiques
      })

      // slider slots
      $(document).ready(() => {
        $(document).foundation();

        // Scroll to filtres & list shop
        if ($(".form-places__container").length) {
          this.utils.scrollTo(".form-places__container");
        }
      });
    }

    const url = this
      .router
      .createUrlTree(['/' + this.buSlug, this.eventSlug, this.formPlaces.value.region, this.formPlaces.value.ville, , this.formPlaces.value.lieu])
      .toString();
    this.location.go(url);
  }

  /**
   * API Récupère les informations de l'évènement par le slug
   *
   * @param eventSlug | String : Slug de l'évènement
   */
  private getEventInformation(eventSlug): void {
    this.coreService.getEvent(eventSlug).subscribe(
      (data) => {
        // Attribution des éléments de event
        this.event = data;

        // Attribution du nom de la BU dans le header
        this.buNameService.name = data.buName;
        // Attribution de l'url de la BU dans le header
        this.buNameService.url = data.buSlug;
        // Attribution de l'img de la BU dans le header
        this.buNameService.img = (typeof data.buLogo != "undefined") ? data.buLogo : "default";
        // Changement de title du site
        this.buNameService.title = data.name;
        if (this.event.virtual) {
          this.today.setTime((this.today.getTime() + this.event.closing_registration_delay * 60 * 60 * 1000));
          this.dataVirtualEvents = data;
        }

        this.filtres = (data.regions) ? data.regions : false;
        // MAJ options select région
        this.dataRegionSelect = new Array();
        this.objectKeys(this.filtres).forEach((key) => {
          this.dataRegionSelect = [
            ...this.dataRegionSelect,
            {
              "id": key,
              "name": this.filtres[key].name
            }
          ]
        });

        // On récupère l'id du Slot si il existe
        this.route
          .queryParamMap
          .subscribe((params: ParamMap) => {
            if (this.idRegion) {
              this.formPlaces.get('region').patchValue(this.idRegion);
              this.changeRegion();
            }
            if (this.idVille) {
              this.formPlaces.get('ville').patchValue(this.idVille);
              this.changeVille();
            }
            if (this.idLieu) {
              this.formPlaces.get('lieu').patchValue(this.idLieu);
              this.changeLieu();
            }
          });

      }, (dataError) => {
        this.filtres = false;
        this.errorApi = true;
      }, () => { });
  }

  public formValid(): boolean {
    return this.formPlaces.value.lieu.length == 0 ||
      this.formPlaces.value.region.length == 0 ||
      this.formPlaces.value.ville.length == 0
  }

  public goToStep(number) {
    this.dataChange.emit({
      ...this.data,
      step: number,
      ville: this.formPlaces.value.ville,
      region: this.formPlaces.value.region,
      lieu: this.formPlaces.value.lieu
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/todo_remove/lieu/lieu.component.ts